export default __webpack_public_path__ + "static/media/personal-portfolio-landing.c6e1f2a7.png";